import Axios from "axios";
import {
    SET_SALES_TEAM_TARGET_LIST,
    UNSET_SALES_TEAM_TARGET_LIST,
} from "@/store/mutation-types";
import { saveUpdateSalesTeamTarget, getSalesTeamTargetList } from "@/store/api";

const state = {
    getSalesTeamTargetList: [],
    editingSalesTeamTarget: null,
};

const getters = {
    getSalesTeamTargetList(state) {
        return state.getSalesTeamTargetList;
    },
    getEditingSalesTeamTarget(state) {
        return state.editingSalesTeamTarget;
    }
};

const mutations = {
    [SET_SALES_TEAM_TARGET_LIST](state, data) {
        state.getSalesTeamTargetList = data;
    },
    [UNSET_SALES_TEAM_TARGET_LIST](state) {
        state.getSalesTeamTargetList = [];
    },
    seteditingSalesTeamTarget(state, data) {
        state.editingSalesTeamTarget = data;
    }
};

const actions = {
    saveUpdateSalesTeamTarget({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateSalesTeamTarget, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalesTeamTargetList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesTeamTargetList, { params: data })
                .then(function (response) {
                    commit("SET_SALES_TEAM_TARGET_LIST", response.data.data);
                    resolve(response.data.data);
                })
                .catch(function (error) {
                    commit("UNSET_SALES_TEAM_TARGET_LIST");
                    reject(error);
                })
                .then((always) => {});
        });
    },

    getSaleTeamTargetById({ commit }, data) {
        const getSaleTeamTargetByIdApi = `${getSalesTeamTargetList}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSaleTeamTargetByIdApi)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
